var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToHomescreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(215,215,215,0);}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 22,
    transform: "translate(0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16,22H6a6.007,6.007,0,0,1-6-6V6A6.007,6.007,0,0,1,6,0H16a6.007,6.007,0,0,1,6,6V16A6.006,6.006,0,0,1,16,22ZM6.914,10.372a.629.629,0,0,0,0,1.257h3.458v3.457a.629.629,0,0,0,1.257,0V11.629h3.457a.629.629,0,0,0,0-1.257H11.629V6.914a.629.629,0,0,0-1.257,0v3.458Z",
    transform: "translate(0.11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToHomescreen);
export default __webpack_public_path__ + "static/media/AddToHomescreen.dbb9a4d68a70b343b17e0cfc19b3c859.svg";
export { ForwardRef as ReactComponent };